import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home.vue'
import Home2 from '@/pages/Home2.vue'
import About from '@/pages/About.vue'
import Service from '@/pages/Service.vue'
import Error from '@/pages/Error.vue'
import Contact from '@/pages/Contact.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/home-2',
            name: 'Home Two',
            component: Home2,
        },
        {
            path: '/about',
            name: 'About Us',
            component: About,
        },
        {
            path: '/service',
            name: 'Service',
            component: Service,
        },
        {
            path: '/404',
            name: 'Error',
            component: Error,
        },
        {
            path: '/contact-us',
            name: 'Contact Us',
            component: Contact,
        },
    ],
    mode: "history",
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js